/**
 * Sets all the screens of the app under their respective routes.
 */

/** */
import React from "react";
import { HashRouter as Router, Switch, Route, useHistory } from "react-router-dom";
import Loadable from "react-loadable";
import ProtectedScreenHome from "../pages/Protected";
import {
    COMPLETE_DEFAULT_SIGNUP_ROUTE,
    CONTACT_REGISTER_ROUTE,
    DOCUMENT_SIGN_ROUTE,
    USER_ORG_INVITE_ROUTE,
    HOME_ROUTE,
    LOGOUT_ROUTE,
    SIGNUP_ROUTE,
    COMPLETE_DEALER_GROUP_SIGNUP_ROUTE,
    APP_AUTH_INIT_ROUTE,
    INTERNAL_LOGIN_ROUTE,
    ORGANIZATIONS_ROUTE,
    DEALER_GROUP_REQUESTED_ROUTE,
} from "../constants/appRoutes";
import RouteComponentHOC from "./routeHelpers/RouteComponent";
import LoginPage from "../pages/Authentication/Login/Login";
import RequiresAuth from "./routeHelpers/RequiresAuth";
import RequiresNoAuth from "./routeHelpers/RequiresNoAuth";
import LogoutPage from "../pages/Authentication/Logout/Logout";
import SignupPage from "../pages/Authentication/Signup/Signup";
import CompleteDefaultSignup from "../pages/Authentication/CompleteSignup/CompleteDefaultSignup";
import CheckAuth from "../pages/Authentication/CheckAuth/CheckAuth";
import { AppStoreActions } from "../redux/services/app/actions";
// import ContactFormCompletePage from "../pages/ExternalPages/ContactFormCompletePage/ContactFormCompletePage";
// import ContactDocumentSignPage from "../pages/ExternalPages/ContactDocumentSignPage/ContactDocumentSignPage";
import Loading from "../components/Loading/Loading";
import BasicHeaderLayout from "../layouts/BasicHeaderLayout/BasicHeaderLayout";
import Page404 from "../pages/ExtraPages/Page404";
import CompleteDealerGroupSignup from "../pages/Authentication/CompleteSignup/CompleteDealerGroupSignup";
import { APP_ENV } from "../constants/appVars";
import AppInit from "../pages/Authentication/AppInit/AppInit";
import DealerGroupRequestedPage from "../pages/ExternalPages/DealerGroupRequestedPage";

const ContactFormCompletePage = Loadable({
    loader: () => import("../pages/ExternalPages/ContactFormCompletePage/ContactFormCompletePage"),
    loading: () => <BasicHeaderLayout content={<Loading text="Initializing" />} title="" />,
});

const ContactDocumentSignPage = Loadable({
    loader: () => import("../pages/ExternalPages/ContactDocumentSignPage/ContactDocumentSignPage"),
    loading: () => <BasicHeaderLayout content={<Loading text="Initializing" />} title="" />,
});

const OrgInvitationPage = Loadable({
    loader: () => import("../pages/ExternalPages/OrgInvitePage"),
    loading: () => <BasicHeaderLayout content={<Loading text="Initializing" />} title="" />,
});

const GlobalRouterProvider = () => {
    const history = useHistory();
    AppStoreActions.saveRouterHistory(history);
    return <></>;
};

const AppRoutes = () => {
    return (
        <Router>
            <GlobalRouterProvider />
            {APP_ENV.BUILD_TARGET === "x-sign-pages" ? (
                <Switch>
                    <Route path={CONTACT_REGISTER_ROUTE} component={RouteComponentHOC(ContactFormCompletePage)} />
                    <Route path={DOCUMENT_SIGN_ROUTE} component={RouteComponentHOC(ContactDocumentSignPage)} />
                    <Route component={RouteComponentHOC(Page404)} />
                </Switch>
            ) : (
                <Switch>
                    <Route path={INTERNAL_LOGIN_ROUTE} component={RequiresNoAuth(LoginPage)} />
                    <Route path={APP_AUTH_INIT_ROUTE} component={RouteComponentHOC(AppInit)} />
                    <Route path={LOGOUT_ROUTE} component={RouteComponentHOC(LogoutPage)} />
                    <Route path={SIGNUP_ROUTE} component={RouteComponentHOC(SignupPage)} />
                    <Route path={COMPLETE_DEFAULT_SIGNUP_ROUTE} component={RouteComponentHOC(CompleteDefaultSignup)} />
                    <Route path={COMPLETE_DEALER_GROUP_SIGNUP_ROUTE} component={RouteComponentHOC(CompleteDealerGroupSignup)} />
                    <Route path={CONTACT_REGISTER_ROUTE} component={RouteComponentHOC(ContactFormCompletePage)} />
                    <Route path={DOCUMENT_SIGN_ROUTE} component={RouteComponentHOC(ContactDocumentSignPage)} />
                    <Route path={USER_ORG_INVITE_ROUTE} component={RouteComponentHOC(OrgInvitationPage)} />
                    <Route path={DEALER_GROUP_REQUESTED_ROUTE} component={RouteComponentHOC(DealerGroupRequestedPage)} />
                    <Route path={HOME_ROUTE} component={RequiresAuth(ProtectedScreenHome)} />
                    <Route component={RouteComponentHOC(CheckAuth)} />
                </Switch>
            )}
        </Router>
    );
};

export default AppRoutes;
